import React from 'react';
import type from '../constant/type';

class Alert extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: this.props.show
    };
    this.handleClose = this.handleClose.bind(this);
  }

  handleClose(e) {
    const { dispatch } = this.props;

    dispatch({
      type: type.STORE_INVOICE_DATA,
      payload: {
        key: 'notify',
        data: {
          show: false
        }
      }
    });
  }
  render() {
    const { msg, status, show } = this.props;
    //const { show } = this.state;

    return (
      <div
        className={`alert app-alert ${status === '1' ? 'ok' : 'error'}  ${!show ? 'd-none' : ''}`}>
        <span>{msg}</span>
        <button
          className={` btn alert-close-btn ${status === '1' ? 'btn-success' : 'btn-danger'} `}
          onClick={(e) => {
            this.handleClose(e);
          }}>
          <ion-icon name="close"></ion-icon>
        </button>
      </div>
    );
  }
}
export default Alert;
